var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.color,"small":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleConvertToOwner($event)}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }